import {useState, useEffect, useCallback} from 'react'
import useDebounce from '../../context/hooks/useDebounce';
import { useNavigate } from 'react-router-dom';
import useAxiosPrivate from '../../context/hooks/useAxiosPrivate';
import {Table, Spinner, Form, ButtonGroup, ToggleButton} from 'react-bootstrap';
import ListPaginator from '../../components/ListPaginator';
import ExcelInvoice from '../../components/ExcelInvoice';
import '../../appstyles/ClientsCSS/ClientsList.css';
import PermissionWrapper from '../../context/PermissionWrapper';
import BulkInvoiceButton from '../../components/BulkInvoiceButton';

function AccountReceivableClients() {
  const axiosInstance = useAxiosPrivate();
  const [invoices, setInvoices] = useState({ data: [] });
  const [loading, setLoading] = useState(false)
  const [status, setStatus] = useState('Pendiente');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounce(search, 700);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [bulkResult, setBulkResult] = useState(null);
  const navigate = useNavigate();

  const handleFilterChange = (event) => {
    setStatus(event.target.value);
  };

  const radios = [
    { name: 'Pagado', value: 'Pagado' },
    { name: 'Pendiente', value: 'Pendiente' },
    { name: 'Vencido', value: 'Vencido' }
  ];

  const fetchInvoices = useCallback((page, searchQuery, pageSize) => {
    setLoading(true);
    const url = searchQuery
      ? `api/financial/?page=${page}&size=${pageSize}&invoice_type=Cuenta por cobrar de cliente&status=${status}&search=${searchQuery}`
      : `api/financial/?page=${page}&size=${pageSize}&invoice_type=Cuenta por cobrar de cliente&status=${status}`;

    axiosInstance.get(url)
      .then(response => {
        setInvoices(response.data);
        setTotalPages(response.data.totalPages);
      })
      .catch(error => {
        console.log('Failed to fetch invoices', error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [axiosInstance, status]);

  useEffect(() => {
      fetchInvoices(currentPage, debouncedSearch, rowsPerPage);
    }, [currentPage, debouncedSearch, status, rowsPerPage, fetchInvoices]);

  const handleRowClick = (invoiceId) => {
  navigate(`/clientsreceivableinvoice/details/${invoiceId}`);
  };

  const handlePageChange = (pageNumber) => {
      setCurrentPage(pageNumber);
  };


  return (
    <div className='maestros-list'>
      <h2>Cuentas por Cobrar Locales</h2>
      <hr />
      <div style={{ maxWidth: '250px' }}>
        <BulkInvoiceButton axiosInstance={axiosInstance} onResult={setBulkResult} />
      </div>
      {bulkResult && (
        <div style={{ marginBottom: '1rem', fontWeight: 'bold', color: '#155724', background: '#d4edda', border: '1px solid #c3e6cb', padding: '0.75rem', borderRadius: '4px' }}>
          {bulkResult.message}
          {typeof bulkResult.created_invoices !== 'undefined' && (
            <div>Facturas creadas: {bulkResult.created_invoices}</div>
          )}
        </div>
      )}
      <Form.Control
        style={{ width: '50%' }}
        type="search"
        placeholder="Buscar por nombre de cliente, consecutivo o factura"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
      <div className='filter-container'>
        <ButtonGroup toggle style={{width: '20%'}}>
        {radios.map((radio, idx) => (
          <ToggleButton
            key={idx}
            id={`radio-${idx}`}
            type="radio"
            variant='outline-secondary'
            name="radio"
            value={radio.value}
            checked={status.toString() === radio.value}
            onChange={(e) => handleFilterChange(e)}
          >
            {radio.name}
          </ToggleButton>
          ))}
        </ButtonGroup>
      </div>
      {loading ? (
        <div className='loading-container'>
          <p style={{fontFamily: 'Roboto, sans-serif'}}>Cargando...</p>
          <Spinner animation="border" variant="info" style={{width: '4.5rem', height: '4.5rem'}} />
        </div>
      ) : (
        <Table striped bordered hover responsive style={{overflowY: 'auto'}}>
          <thead>
            <tr>
              <th style={{ minWidth: '150px' }}>Consecutivo de Orden</th>
              <th style={{ minWidth: '150px' }}>Número de Factura</th>
              <th style={{ minWidth: '150px' }}>Fecha de Facturación</th>
              <th style={{ minWidth: '150px' }}>Cliente</th>
              <th style={{ minWidth: '150px' }}>Fecha de Vencimiento</th>
              <th style={{ minWidth: '150px' }}>Valor Total</th>
              <th style={{ minWidth: '150px' }}>Valor Pendiente</th>
              <th style={{ minWidth: '150px' }}>Moneda</th>
            </tr>
          </thead>
          <tbody>
            {invoices.data && invoices.data.map(invoice => (
              <tr key={invoice.id} onClick={() => handleRowClick(invoice.id)} style={{ cursor: 'pointer' }}>
                <td style={{ minWidth: '150px' }}>{invoice.quote_details.consecutive}</td>
                <td style={{ minWidth: '150px' }}>{invoice.invoice_number ? invoice.invoice_number : '-'}</td>
                <td style={{ minWidth: '150px' }}>{invoice.invoice_date ? invoice.invoice_date : '-'}</td>
                <td style={{ minWidth: '150px' }}>{invoice.quote_details.client_name}</td>
                <td style={{ minWidth: '150px' }}>{invoice.due_date ? invoice.due_date : '-'}</td>
                <td style={{ minWidth: '150px' }}>{invoice.amount_total ? invoice.amount_total : '-'}</td>
                <td style={{ minWidth: '150px' }}>{invoice.amount_due ? invoice.amount_due : '-'}</td>
                <td style={{ minWidth: '150px' }}>{invoice.quote_details.currency ? invoice.quote_details.currency : '-'}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
      <div style={{marginTop: '1.5rem'}}>
        <div style={{display: 'flex', alignItems: 'center'}}>
          <div style={{flex: 1}}>
            <PermissionWrapper feature="financiero_receivables_local" action="excel">
              <ExcelInvoice invoiceType="Cuenta por cobrar de cliente" label="Exportar Excel" />
            </PermissionWrapper>
          </div>
          <div style={{flex: 1, display: 'flex', justifyContent: 'flex-end'}}>
            <ListPaginator
              currentPage={currentPage}
              totalPages={totalPages}
              rowsPerPage={rowsPerPage}
              onPageChange={handlePageChange}
              onRowsPerPageChange={value => {
                setRowsPerPage(value);
                setCurrentPage(1);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AccountReceivableClients;